export const rulesConstants = {
	INCLUDE: 'include'
};

export const rules = [rulesConstants.INCLUDE];

export const defaultPath = 'source.theme.variants[0].';
